// import { convertToRaw } from "draft-js";
import { CustomFieldPossibleValuesFieldMap } from "../components/DocumentV2/DynamicField/DynamicFieldComponents/CustomFieldRulesMap";
// Internal Imports
import { DOCUMENTS, BILLING } from "../constants";
import { normaliseTableData } from "./tableUtils";
import { readDataFromLocalStorage } from "./globalUtils";

// Destructuring
const { DOCUMENT_COMPONENT_TYPES } = DOCUMENTS;
const { BILLING_PLANS } = BILLING;

export const getCSVColunName = (key, fieldsData, type, meta) => {
  let dataKey = fieldsData.label;
  dataKey = dataKey.trim();
  if (key !== "default" && key !== "format") {
    dataKey += ` ${key}`;
  }
  if (key === "format") {
    dataKey += ` (Allowed format - ${meta.format})`;
  }
  if (
    meta.options &&
    meta.options.length > 0 &&
    CustomFieldPossibleValuesFieldMap[type] === key
  ) {
    dataKey += ` (Allowed values - ${meta.options.join("/")})`;
  }

  return dataKey;
};

export const compareColumns = (columns, headers) => {
  for (let i = 0; i < headers.length; i += 1) {
    if (columns.indexOf(headers[i]) < 0) {
      return false;
    }
  }
  return true;
};

export const validatePossibleValues = csvdata => {
  const errors = [];
  // eslint-disable-next-line no-restricted-syntax
  for (const key in csvdata) {
    if (key.indexOf("Allowed values") > 0) {
      const possibleValues = key.split("Allowed values - ")[1].slice(0, -1);
      const possibleArr = possibleValues.split("/");

      const dataArr = csvdata[key].split(",");
      dataArr.forEach(da => {
        if (possibleArr.indexOf(da) < 0) {
          errors.push(`"${da}" is not allowed in ${key} column`);
        }
      });
    }
  }
  return errors;
};

const getTextFields = (componentMeta, data) => {
  // const rawData = convertToRaw(data);
  const { entityMap: entityData } = data;
  const formFields = [];
  if (entityData && Object.keys(entityData).length > 0)
    Object.values(entityData).forEach(entity => {
      if (entity.data && entity.data.dynamicFieldId) {
        formFields.push({
          fieldId: entity.data.dynamicFieldId,
          occurenceId: entity.data.id,
          componentMeta,
        });
      }
    });
  return formFields;
};

const getHTMLFields = (componentMeta, section) => {
  const { data, clauseOptions } = section;
  let formFields = [];
  if (clauseOptions && clauseOptions.id) {
    formFields.push({ fieldId: clauseOptions.id, componentMeta });
  } else if (data && typeof data !== "string") {
    formFields = getTextFields({ ...componentMeta }, data);
  }
  return formFields;
};

const getImageFields = (componentMeta, section) => {
  const { clauseOptions } = section;
  const formFields = [];
  if (clauseOptions && clauseOptions.id) {
    formFields.push({ fieldId: clauseOptions.id, componentMeta });
  }
  return formFields;
};

const getTableFields = (componentMeta, section) => {
  const { data: tableData, clauseOptions } = section;
  const hiddenCols =
    tableData.attributes && Array.isArray(tableData.attributes.hiddenCols)
      ? tableData.attributes.hiddenCols
      : [];
  const { data: rowData } = normaliseTableData(tableData, null, hiddenCols);
  let formfields = [];
  rowData.forEach((row, rowIndex) => {
    const { data: columnData } = row;
    columnData.forEach((column, colIndex) => {
      const {
        data: { data: cellData },
      } = column;
      let cellFields = [];
      if (cellData && typeof cellData !== "string") {
        cellFields = getTextFields(
          {
            ...componentMeta,
            itemType: "Table",
            tableRow: rowIndex,
            tableCol: colIndex,
          },
          cellData,
        );
      }
      if (Array.isArray(cellFields) && cellFields.length > 0)
        formfields = [...formfields, ...cellFields];
    });
  });
  if (clauseOptions && clauseOptions.id) {
    formfields = [{ fieldId: clauseOptions.id, componentMeta }, ...formfields];
  }
  return formfields;
};

const getCoverpageFields = (componentMeta, component) => {
  const { data } = component;
  let formfields = [];
  const { layout, components } = data;
  if (Array.isArray(layout) && layout.length > 0) {
    layout.forEach(rowData => {
      if (Array.isArray(rowData) && rowData.length > 0) {
        rowData.forEach(sectionId => {
          const section = components[sectionId].content;
          // eslint-disable-next-line no-use-before-define
          const fields = getComponentFields(
            {
              ...componentMeta,
              sectionId,
              blockType: "Coverpage",
            },
            section,
          );
          if (Array.isArray(fields) && fields.length > 0) {
            formfields = [...formfields, ...fields];
          }
        });
      } else if (rowData && !Array.isArray(rowData)) {
        const section = components[rowData].content;
        // eslint-disable-next-line no-use-before-define
        const fields = getComponentFields(
          {
            ...componentMeta,
            section: section.id || componentMeta.id,
            blockType: "Coverpage",
          },
          section,
        );
        if (Array.isArray(fields) && fields.length > 0) {
          formfields = [...formfields, fields];
        }
      }
    });
  }
  return formfields;
};

const getHeaderFooterFields = (componentMeta, component) => {
  const { data } = component;
  const { header, footer } = data;
  const formfieldsObj = {};
  const { layout: hlayout, components: hcomponents } = header;
  if (Array.isArray(hlayout) && hlayout.length > 0) {
    let headerformfields = [];
    hlayout.forEach(rowData => {
      if (Array.isArray(rowData) && rowData.length > 0) {
        rowData.forEach(sectionId => {
          const section = hcomponents[sectionId].content;
          // eslint-disable-next-line no-use-before-define
          const fields = getComponentFields(
            {
              ...componentMeta,
              sectionId,
              blockType: "Header",
            },
            section,
          );
          if (Array.isArray(fields) && fields.length > 0) {
            headerformfields = [...headerformfields, ...fields];
          }
        });
      } else if (rowData && !Array.isArray(rowData)) {
        const section = hcomponents[rowData].content;
        // eslint-disable-next-line no-use-before-define
        const fields = getComponentFields(
          {
            ...componentMeta,
            sectionId: section.id || componentMeta.id,
            blockType: "Header",
          },
          section,
        );
        if (Array.isArray(fields) && fields.length > 0) {
          headerformfields = [...headerformfields, fields];
        }
      }
    });
    formfieldsObj.header = headerformfields;
  }

  const { layout: flayout, components: fcomponents } = footer;
  if (Array.isArray(flayout) && flayout.length > 0) {
    let footerformfields = [];
    flayout.forEach(rowData => {
      if (Array.isArray(rowData) && rowData.length > 0) {
        rowData.forEach(sectionId => {
          const section = fcomponents[sectionId].content;
          // eslint-disable-next-line no-use-before-define
          const fields = getComponentFields(
            {
              ...componentMeta,
              sectionId,
              blockType: "Footer",
            },
            section,
          );
          if (Array.isArray(fields) && fields.length > 0) {
            footerformfields = [...footerformfields, ...fields];
          }
        });
      } else if (rowData && !Array.isArray(rowData)) {
        const section = fcomponents[rowData].content;
        // eslint-disable-next-line no-use-before-define
        const fields = getComponentFields(
          {
            ...componentMeta,
            sectionId: section.id || componentMeta.id,
            blockType: "Footer",
          },
          section,
        );
        if (Array.isArray(fields) && fields.length > 0) {
          footerformfields = [...footerformfields, fields];
        }
      }
    });
    formfieldsObj.footer = footerformfields;
  }

  return formfieldsObj;
};

const getComponentFields = (componentMeta, component) => {
  let componentFields = [];
  if (component.type === DOCUMENT_COMPONENT_TYPES.HTML) {
    componentFields = getHTMLFields(componentMeta, component);
  } else if (component.type === DOCUMENT_COMPONENT_TYPES.IMAGE) {
    componentFields = getImageFields(componentMeta, component);
  } else if (component.type === DOCUMENT_COMPONENT_TYPES.TABLE) {
    componentFields = getTableFields(componentMeta, component);
  } else if (component.type === DOCUMENT_COMPONENT_TYPES.COVERPAGE) {
    componentFields = getCoverpageFields(componentMeta, component);
  } else if (component.type === DOCUMENT_COMPONENT_TYPES.HEADER_FOOTER) {
    componentFields = getHeaderFooterFields(componentMeta, component);
  }
  return componentFields;
};

export const getOrderedComponents = (layout, components) => {
  const orderedComponents = {};
  layout.forEach(row => {
    row.forEach(colId => {
      if (!orderedComponents[colId]) {
        orderedComponents[colId] = { ...components[colId] };
      }
    });
  });
  return orderedComponents;
};

export const getFormFields = (components, fieldsUsed) => {
  let bodyformfields = [];
  let headerformfields = [];
  let footerformfields = [];
  let coverpageformfields = [];
  // get all the fields
  Object.keys(components).forEach(componentId => {
    const section = components[componentId]
      ? components[componentId].content
      : {};
    const componentMeta = {
      componentId,
      itemType: section.type,
      blockType: "Body",
    };
    const componentFields = getComponentFields(componentMeta, section);
    // For Coverpage
    if (
      section.type === DOCUMENT_COMPONENT_TYPES.COVERPAGE &&
      Array.isArray(componentFields) &&
      componentFields.length > 0
    ) {
      coverpageformfields = componentFields;
    }
    // For Header
    else if (
      section.type === DOCUMENT_COMPONENT_TYPES.HEADER_FOOTER &&
      Object.keys(componentFields).length > 0
    ) {
      headerformfields = componentFields.header;
      footerformfields = componentFields.footer;
    } else if (Array.isArray(componentFields) && componentFields.length > 0)
      bodyformfields = [...bodyformfields, ...componentFields];
  });

  let formfields = [];
  if (Array.isArray(coverpageformfields) && coverpageformfields.length > 0) {
    formfields = [...formfields, ...coverpageformfields];
  }
  if (Array.isArray(headerformfields) && headerformfields.length > 0) {
    formfields = [...formfields, ...headerformfields];
  }
  if (Array.isArray(bodyformfields) && bodyformfields.length > 0) {
    formfields = [...formfields, ...bodyformfields];
  }
  if (Array.isArray(footerformfields) && footerformfields.length > 0) {
    formfields = [...formfields, ...footerformfields];
  }
  // get all unique fields with occurences
  const arrangedFields = [];
  formfields.forEach(field => {
    const fieldDetails = fieldsUsed.find(df => df.id === field.fieldId);
    if (fieldDetails) {
      const isAvailable = arrangedFields.includes(field.fieldId);
      if (!isAvailable) {
        arrangedFields.push(field.fieldId);
      }
    }
  });

  return arrangedFields;
};

export const checkEnterpriseUser = () => {
  const userSignUpInfo = readDataFromLocalStorage("userSignUpInfo");
  const currentPlan = userSignUpInfo && userSignUpInfo.billing_plan;
  if (
    currentPlan.split("-").includes("enterprise") ||
    currentPlan === BILLING_PLANS.ENTERPRISE_MONTHLY ||
    currentPlan === BILLING_PLANS.ENTERPRISE_ANNUAL ||
    currentPlan === BILLING_PLANS.ENTERPRISE_ANNUAL_V3 ||
    currentPlan === BILLING_PLANS.ENTERPRISE_MONTHLY_V3 ||
    currentPlan === BILLING_PLANS.ENTERPRISE_ANNUAL_V3_1 ||
    currentPlan === BILLING_PLANS.ENTERPRISE_ANNUAL_V3_2 ||
    currentPlan === BILLING_PLANS.ENTERPRISE_ANNUAL_V3_3 ||
    currentPlan === BILLING_PLANS.ENTERPRISE_MONTHLY_V3_1 ||
    currentPlan === BILLING_PLANS.ENTERPRISE_MONTHLY_V3_2 ||
    currentPlan === BILLING_PLANS.ENTERPRISE_MONTHLY_V3_3
  ) {
    return true;
  }
  // this has been added for dev purpose
  if (window.location.href.includes("localhost")) {
    return true;
  }
  return false;
};
